// extracted by mini-css-extract-plugin
export default {"checkbox":"SignUpForm_checkbox__CpvCx","caption":"SignUpForm_caption__Njg2i"};